import { AuthConstants } from 'constants/auth';
import { createAction } from 'redux-actions';

export const signIn = createAction(AuthConstants.AUTH_SIGN_IN);
export const signOut = createAction(
  AuthConstants.AUTH_SIGN_OUT,
  (navigate) => ({ navigate })
);
export const completeMfaChallenge = createAction(
  AuthConstants.AUTH_COMPLETE_MFA_CHALLENGE
);
export const selectMfaMethod = createAction(
  AuthConstants.AUTH_SELECT_MFA_METHOD
);
export const switchMfaMethod = createAction(
  AuthConstants.AUTH_SWITCH_MFA_METHOD
);
